import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private spinnerShow = new BehaviorSubject<boolean>(false);

  constructor() { }


  showSpinner() {
    this.spinnerShow.next(true);
  }

  hideSpinner() {
    this.spinnerShow.next(false);
  }
  getShowSpinner(): Observable<boolean> {
    return this.spinnerShow.asObservable();
  }

}
